import { call, put, takeEvery } from 'redux-saga/effects'

import { Types, types } from '../../types'
import { getCreditDetails, getDashboardData, getFaxInfo, getFreeIvrPackageRequest, getFreeSecretaryPackageRequest, getIvrInfo, getSecretaryInfo } from '../apiRequests/srvicesRequest'
import { getCreditDetailsResponse } from '../../types/serviceDashboard/apiRequestType'
import { creditDetailsErrorAction, creditDetailsSuccessAction } from '../../actions/servicesAction'
import { getDashboardDataErrorAction, getDashboardDataSuccessAction, getFaxInfoErrorAction, getFaxInfoSuccessAction, getFreeIVRSuccessAction, getFreeSecretaryErrorAction, getFreeSecretarySuccessAction, getIvrInfoErrorAction, getIvrInfoSuccessAction, getSecretaryInfoErrorAction, getSecretaryInfoSuccessAction } from '../../actions/servicesAction'
import { getDashboard, getFreeService, getService } from '../../types/serviceDashboard/apiRequestTypes'







function* getCreditDetailsHandler(action: any) {
    try {
        const response: { data: any } = yield call(getCreditDetails, action.payload.params)
        yield put(
            creditDetailsSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            creditDetailsErrorAction({
                error: error.message
            })
        )
    }
}
function* handleSecretaryInfoService(action: any) {
    try {
        const response: { data: getService } = yield call(getSecretaryInfo)
        yield put(
            getSecretaryInfoSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            getSecretaryInfoErrorAction({
                error: error.message
            })
        )
    }
}

function* handleIvrInfoService(action: any) {
    try {
        const response: { data: getService } = yield call(getIvrInfo)

        yield put(getIvrInfoSuccessAction({
            params: response.data
        }))
    } catch (error: any) {
        yield put(getIvrInfoErrorAction({
            error: error.message
        }))
    }
}

function* handleFaxInfoService(action: any) {
    try {
        const response: { data: getService } = yield call(getFaxInfo)
        yield put(getFaxInfoSuccessAction({
            params: response.data,
        }))
    } catch (error: any) {
        yield put(getFaxInfoErrorAction({
            error: error.message,
        }))
    }
}


function* handledashboardData(action: any) {

    try {
        const response: { data: getDashboard } = yield call(getDashboardData)
        yield put(getDashboardDataSuccessAction({
            params: response.data,
        }))
    } catch (error: any) {
        yield put(getDashboardDataErrorAction({
            error: error.message,
        }))
    }
}


function* handleGetFreeIvrPackageRequest(action: any) {
    try {
        const response: { data: getFreeService } = yield call(getFreeIvrPackageRequest)
        yield put(getFreeIVRSuccessAction({
            params: response.data,
        }))
    } catch (error: any) {
        yield put(getFreeSecretaryErrorAction({
            error: error.response,
        }))
    }
}

function* handleGetFreeSecretaryPackageRequest(action: any) {
    try {
        const response: { data: getFreeService } = yield call(getFreeSecretaryPackageRequest)
        yield put(getFreeSecretarySuccessAction({

            params: response.data,
        }))
    } catch (error: any) {
        yield put(getFreeSecretaryErrorAction({
            error: error.response,
        }))
    }
}






function* watcherServicesSaga() {
    yield takeEvery(Types.GET_CREDIT_DETAILS_REQUEST, getCreditDetailsHandler)
    yield takeEvery(Types.GET_SECRETARY_INFO_SERVICE_REQUEST, handleSecretaryInfoService)
    yield takeEvery(Types.GET_IVR_INFO_SERVICE_REQUEST, handleIvrInfoService)
    yield takeEvery(Types.GET_FAX_INFO_SERVICE_REQUEST, handleFaxInfoService)
    yield takeEvery(Types.GET_DASHBOARD_DATA_REQUEST, handledashboardData)
    yield takeEvery(Types.GET_FREE_IVR_PACKAGE_REQUEST, handleGetFreeIvrPackageRequest)
    yield takeEvery(Types.GET_FREE_SECRETARY_PACKAGE_REQUEST, handleGetFreeSecretaryPackageRequest)


}


export default watcherServicesSaga
